module.exports = __webpack_public_path__ + "images/emoji/phone.c48bb7af3f6afdf42dd3.png";